import store from "../../../../../redux/store";
import { create_account } from "../../../../../services/api/Accounts";
import { createReport, updateReport } from "../../../services/api/Report"


export const handleFinalizeReport = (report, alertMessage, navigate, lang, isEditMode) => {

    store.dispatch({type: "SAVE_GOOGLE_REPORT", payload: report});

    if ( !isEditMode ) {

        // create Account 
        create_account(report?.clientAccount?.name, report?.userId, "google").catch((err) => console.log('err',err));

        // const payload = {...report, template: report?.kpis?.map((kpi) => {return kpi?.originalKey})}
        const payload = report;
        createReport(payload)
            .then((res) => {
                if ( res?.data?.data?.report ){
                    navigate(`/${lang}/google/report/${res.data.data.report?._id}`)
                    alertMessage("Report created", "Success")
                } else alertMessage("Something went wrong", "Error")
            }).catch(err=>console.error(err));
    } else {
        const payload = report;
        updateReport(payload._id, payload)
            .then((res) => {
                alertMessage("Report updated", "Success")
                navigate(`/${lang}/google/report/${payload._id}`)
            }).catch(err=>console.error(err));
    }
}